import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  TextField,
  Stack,
  InputAdornment,
  Box,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useQuery } from "@apollo/client";
import AddIngredients from "../inventory/AddIngredients";
import { useNotification } from "../../Context/notificationContext";
import { GET_INGREDIENTS } from "./ChooseGrainsForm";



export default function ChoosePasteForm({ task, onSubmit }) {
  const [selectedItem, setSelectedItem] = useState(task.item_name || "");
  const [quantity, setQuantity] = useState(task.quantity || "");
  const [error, setError] = useState("");
  const [itemError, setItemError] = useState("");
  const { showNotification } = useNotification();
  const minQuantity = 1;
  const maxQuantity = 10;

  const {
    data,
    loading: getIngredientsLoading,
    error: getIngredientsError,
    refetch: refetchIngredients,
  } = useQuery(GET_INGREDIENTS, {
    variables: {
      ingredientType: "PASTE",
    },
    fetchPolicy: "cache-and-network",
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateForm()) {
      task.args = `${selectedItem} - ${quantity} tea spoon`;
      task.quantity = quantity;
      task.item_name = selectedItem;
      onSubmit(task);
    }
  };

  const validateForm = () => {
    if (!selectedItem) {
      setItemError("Please select a paste bottle");
      setError("");
      return false;
    }
    if (+quantity < minQuantity || +quantity > maxQuantity) {
      setError(
        `Quantity must be between ${minQuantity} and ${maxQuantity} tea spoon`
      );
      setItemError("");
      return false;
    }
    setError("");
    setItemError("");
    return true;
  };

  const [addIngredientActive, setAddIngredientActive] = useState(false);
  const [item_name, setItem_name] = useState("");
  const [ingredientType, setIngredientType] = useState(null);
  const [ingredientImage, setIngredientImage] = useState(null);
  const [ingredients, setIngredients] = useState([]);

  useEffect(() => {
    if (data && data.getIngredients) {
      setIngredients(data.getIngredients);
    }

    if (getIngredientsError) {
      showNotification("error", getIngredientsError.message);
    }
  }, [data, getIngredientsError, showNotification]);

  return addIngredientActive ? (
    // Add Ingredient
    <AddIngredients
      newIngredientName={item_name}
      setNewIngredientName={setItem_name}
      ingredientType={ingredientType}
      setIngredientType={setIngredientType}
      ingredientImage={ingredientImage}
      setIngredientImage={setIngredientImage}
      ingredients={ingredients}
      setIngredients={setIngredients}
      setAddIngredientActive={setAddIngredientActive}
      refetchIngredients={refetchIngredients}
    />
  ) : (
    <form onSubmit={handleSubmit}>
      <Stack spacing={2}>
        <Autocomplete
          options={data?.getIngredients || []} // Provide a default empty array if data is undefined
          getOptionLabel={(option) => option.ingredient_name || ""} // Display ingredient names
          filterOptions={(options, { inputValue }) =>
            options.filter((option) =>
              option.ingredient_name
                .toLowerCase()
                .includes(inputValue.toLowerCase())
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Enter Paste Name"
              variant="outlined"
              value={selectedItem}
              error={!!itemError}
              helperText={itemError}
            />
          )}
          renderOption={(props, option) => (
            <Box
              {...props}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "5px 10px",
              }}
            >
              <img
                src={option.image_url || "/placeholder-16x9.png"} // Use the `image_url` property for the image source
                alt={option.ingredient_name}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <span>{option.ingredient_name}</span>
            </Box>
          )}
          noOptionsText={
            getIngredientsLoading ? (
              <p>Loading ingredients...</p> // Show loading text while fetching ingredients
            ) : (
              <>
                <p>Ingredient not found in the list</p>
                <Button variant="contained" onClick={() => setAddIngredientActive(true)}>Add</Button>
              </>
            )
          }
          onInputChange={(event, newInputValue) =>
            setSelectedItem(newInputValue)
          }
          value={
            ingredients.find((item) => item.ingredient_name === selectedItem) ||
            null
          }
          fullWidth
          disabled={getIngredientsLoading || !data?.getIngredients?.length} // Disable when loading or no ingredients
        />
        <FormControl fullWidth variant="outlined">
          <TextField
            label="Enter Quantity in tea spoon"
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            error={!!error}
            helperText={error}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">tea spoon</InputAdornment>
              ),
            }}
          />
        </FormControl>
        <Button type="submit" variant="contained" color="primary">
          Submit
        </Button>
      </Stack>
    </form>
  );
}
